<template>
  <div v-show="pendingAppointments" class="popup_in">
    <div class="popup pop-pending" v-click-outside="onOutside">
      <div class="popup_close close-animate">
        <a href="javascript:void(0);" @click="$emit('close')"><close-svg /></a>
      </div>
      <h2 class="title">תורים שמועדם השתנה</h2>
      <alarm-page
        @close="$emit('close')"
        :pendingAppointments="pendingAppointments"
      />
    </div>
  </div>
</template>

<script>
import CloseSvg from "@/assets/img/svg/close-sm.svg";
import AlarmPage from "../../views/AlarmPage.vue";
import ClickOutside from "vue-click-outside";
import { mapGetters } from "vuex";

export default {
  name: "PendingAppointmentsDesktop",
  components: { CloseSvg, AlarmPage },
  data() {
    return {
      pendingAppointments: null
    };
  },
  computed: {
    ...mapGetters(["activeDoctor"])
  },
  methods: {
    onOutside() {
      if (this.pendingAppointments) this.$emit("close");
    }
  },
  mounted() {
    try {
      this.$API
        .getPendingAppointments(this.activeDoctor.id)
        .then(res => {
          this.pendingAppointments = res.message;
        })
        .catch(e => {
          this.$modal.show(Error);
        });
    } catch (e) {}
  },
  directives: {
    ClickOutside
  }
};
</script>
